import type { VaultDocumentPort } from '../domain/document'

const archiveDocument = async (port: VaultDocumentPort, documentId: string): Promise<void> => port.archive(documentId)

export { archiveDocument }
